module.exports = __webpack_public_path__ + "img/image-01.66e1fec3.jpeg";